// AUTO-GENERATED by `rdt generate-ts` -- do not edit

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 50;
export const PASSWORD_MIN_LENGTH = 8;
export const NAME_MIN_LENGTH = 1;
export const API_KEY_NAME_MIN_LENGTH = 1;
export const CSV_DELIMITER_LENGTH = 1;
export const DSL_STEPS_MIN_COUNT = 1;
